<template>
  <BreadCrumb v-if="showgrid" page="Beranda > Pendaftaran > Data Transaksi > Lihat Data Transaksi"></BreadCrumb>
  <div class="container-fluid content-area">
    <div class="row">
      <div class="col-md-12">
        <h3 class="judul-seksi-sga">Data Transaksi Pembayaran</h3></div>
    </div>
    <div class="" style="padding-top: 20px;">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <DataTable v-model:filters="filters" :value="dataTransaksi" ref="dt" tableStyle="min-width: 50rem"
                       paginator :rows="10"
                       :rowsPerPageOptions="[5, 10, 20, 50]"
                       :first="0"
                       :loading="loading"
            >
              <template #empty> Data tidak ada. </template>
              <template #loading> Mengambil data. Mohon tunggu. </template>
              <Column field="req_date" header="Trx Date" sortable style="width: 25%"></Column>
              <Column field="inv_refno" header="No formulir" sortable></Column>
              <Column field="anak_nama" header="Nama Anak" filterMatchMode="startsWith" sortable>
              </Column>
              <Column field="ortu_nama" header="Nama Ortu" sortable style="width: 25%"></Column>
              <Column field="payment_name" header="Payment For" sortable style="width: 25%"></Column>
              <Column field="payment_refno" header="Ref No" sortable style="width: 25%"></Column>
              <Column field="payment_transid" header="Trx Id" sortable style="width: 25%"></Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
export default {
  name: "PageDataTransaksiPembayaran",
  components: {BreadCrumb,DataTable,Column},
  data:()=>({
    loading: false,
    lazyParams: {},
    showgrid: true,
    response:'',
    message:'',
    success: false,
    dataTransaksi:[],
    selectedFormulir:[],
    totalRecords: 0,
    filters: {
    },

  }),
  methods:{
    toogleviewshowgrid() {
      this.showgrid = true;
    },
    toggleGrid(data) {
      this.showgrid = !this.showgrid;
      this.selectedFormulir = data;
    },
    getDataTransaksiPembayaran(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataTransaksiPembayaran';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataTransaksi = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    }
  },mounted() {
    this.lazyParams = {
      first: this.$refs.dt.first,
      rows: this.$refs.dt.rows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    this.getDataTransaksiPembayaran();
  }
}
</script>

<style scoped>

</style>